<router-outlet>
</router-outlet>
<simple-notifications></simple-notifications>
<div class="container">
   
</div>
<select *ngIf="!isMobile" class="lang-select z-20" #langSelect (change)="changeLang(langSelect.value)">
    <option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === translate.currentLang">{{ lang }}</option>
</select>
